import axios from "axios";
import changeUrl from './changeUrl'
import qs from "qs";
import VueCookies from "vue-cookies";

axios.defaults.headers.post["Content-Type"] =
  "application/x-www-form-urlencoded;charset=UTF-8";

let base = "http://xxxx.xxxx.com.cn/hubei/doc";
let base1 = "https://schoolapi.eiceducation.com.cn";
let token = VueCookies.get("token");

let testUrl = "https://schoolapi.eiceducation.com.cn"; //测试版
let masterUrl = "https://schoolapi.eiceducation.com.cn"; //正式版
let http = axios.create({
  withCredentials: true,
  headers: {
    "content-type": "application/json; charset=utf-8",
    SystemPaaS: 6,
    PaaSPort: 1,
    codeType:sessionStorage.getItem('codeType')||3,
    token: VueCookies.get("token")
  },
  transformRequest: [
    function(data) {
      let newData = "";
      for (let k in data) {
        if (data.hasOwnProperty(k) === true) {
          newData +=
            encodeURIComponent(k) + "=" + encodeURIComponent(data[k]) + "&";
        }
      }
      return newData;
    }
  ]
});
function apiAxios(method, url, params, response) {
  // if (url) {
  //   if (window.location.host == "online0.eickaopei.com") {
  //     if (url.indexOf(masterUrl) > -1) {
  //       url = url.replace(masterUrl, testUrl);
  //     }
  //   } else {
  //     if (url.indexOf(testUrl) > -1) {
  //       url = url.replace(testUrl, masterUrl);
  //     }
  //   }
  // }
  http({
    method: method,
    url: url,
    data: method === "POST" || method === "PUT" ? params : null,
    params: method === "GET" || method === "DELETE" ? params : null
  })
    .then(function(res) {
      response(res);
    })
    .catch(function(err) {
      response(err);
    });
}

export default {
  get: function(url, params, response) {
    url = changeUrl(url)
    return apiAxios("GET", url, params, response);
  },
  post: function(url, params, response) {
    url = changeUrl(url)
    return apiAxios("POST", url, params, response);
  },
  put: function(url, params, response) {
    url = changeUrl(url)
    return apiAxios("PUT", url, params, response);
  },
  delete: function(url, params, response) {
    url = changeUrl(url)
    return apiAxios("DELETE", url, params, response);
  }
};

// export const bmz = params => { return axios.get(`${base1}/getGroupCodeList`, { params: params }); };

// export const getOptList = params => { return axios.get(`${base1}/getOptList`, { params: params }); };

// export const branchList = params => { return axios.get(`${base1}/branchList`, { params: params }); };

// export const addOperator = params => { return axios.post(`${base1}/addOperator`, qs.stringify(params)).then(res => res.data); };

// export const editBranch = params => { return axios.post(`${base1}/editBranch`, qs.stringify(params)).then(res => res.data);  };

// export const addDzb = params => { return axios.post(`${base1}/addBranch`, qs.stringify(params)).then(res => res.data); };

// export const partlist = params => { return axios.get(`${base1}/branchList`, { params: params }); };

// export const memberList = params => { return axios.get(`${base1}/memberList`, { params: params }); };

// export const selectMember = params => { return axios.get(`${base1}/selectMember`, { params: params }); };

// export const addMember = params => { return axios.get(`${base1}/addMember`, { params: params }); };

// export const branchFeeList = params => { return axios.get(`${base1}/branchFeeList`, { params: params }); };

// export const memberFeeList = params => { return axios.post(`${base1}/getMemberFeeList`, qs.stringify(params)).then(res => res.data); };

// export const getOptNameList = params => { return axios.get(`${base1}/getOptNameList`, { params: params }); };

// export const createTask = params => { return axios.post(`${base1}/createTask`, qs.stringify(params)).then(res => res.data);  };

// export const memberFee = params => { return axios.post(`${base1}/memberFee`, qs.stringify(params)).then(res => res.data);  };

// export const uploadToken = params => { return axios.get(`${base1}/uploadToken`, { params: params });  };

// export const savePic = params => { return axios.post(`${base1}/savePic`, qs.stringify(params)).then(res => res.data);  };



// WEBPACK FOOTER //
// ./src/api/index.js